module.exports = __webpack_public_path__ + "img/Chat.c255cd0f.svg";